import ListSVG from '../../assets/svg/list.svg';
export default ListSVG;
